var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll mt-6",attrs:{"id":"go_live"}},[_c('SectionColumn',{attrs:{"type":"left","title":"Going Live","content":_vm.contentLeftCol}}),_c('SectionColumn',{attrs:{"type":"right","content":_vm.contentRightCol}}),_c('SectionColumn',{attrs:{"type":"left","content":_vm.contentFullCol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }